// import React, { useState, useEffect } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";
// import "./MongoAccountingDashboard.css";
// import Header from "../../Common/Layout/Header";
// import AccountTabs from "../AllTabs/AccountTabs";

// const MongoAccountingDashboard = () => {
//   const { user } = useAuth();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
  
//   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

//   const fetchDashboard = async () => {
//     if (!user?.cid) return;
//     setLoading(true);
//     try {
//       const url = `${config.GETMONGOACCOUNTINGDASHBOARD}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`;
//       const res = await apiService.getAll(url);
//       setData(res);
//     } catch (err) {
//       console.error("Error fetching dashboard:", err);
//       setData(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (user?.cid) fetchDashboard();
//   }, [user?.cid]);

//   const format = (v) => 
//     Number(v || 0).toLocaleString("en-IN", { 
//       style: "currency", 
//       currency: "INR",
//       minimumFractionDigits: 0
//     });

//   return (
//    <div id="layout-wrapper">
//   <Header User={user} />

//   <div className="main-content">
//     <div className="page-content">
//       <div className="container-fluid">

//         {/* ACCOUNT TABS */}
//         <div className="row mb-3">
//           <div className="col-12">
//             <AccountTabs pageName="ACCOUNTDASHBOARD" />
//           </div>
//         </div>

//         {/* TOP ACTION BAR */}
//         <div className="row align-items-center mb-4">
//           <div className="col-md-6">
//             <h3 className="mgaccount-page-heading">Financial Overview</h3>
//             <span className="mgaccount-subheading">
//               Real-time accounting insights for {user?.companyname}
//             </span>
//           </div>

//           <div className="col-md-6">
//             <div className="mgaccount-filter-card shadow-sm">
//               <div className="d-flex align-items-end gap-3">
//                 <div className="mgaccount-date-input-group">
//                   <label>From Date</label>
//                   <input
//                     type="date"
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                   />
//                 </div>

//                 <div className="mgaccount-date-input-group">
//                   <label>To Date</label>
//                   <input
//                     type="date"
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                   />
//                 </div>

//                 <button
//                   className="mgaccount-btn-update"
//                   onClick={fetchDashboard}
//                   disabled={loading}
//                 >
//                   {loading ? "..." : "Generate Report"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {data ? (
//           <>
//             {/* KPI ROW */}
//             <div className="row g-3 mb-4">
//               <KPICard title="Total Income" value={format(data.totalIncome)} icon="ri-line-chart-line" type="income" />
//               <KPICard title="Total Expenses" value={format(data.totalExpenses)} icon="ri-pie-chart-line" type="expense" />
//               <KPICard title="Net Profit" value={format(data.netProfit)} icon="ri-hand-coin-line" type="profit" />
//               <KPICard title="Receivables" value={format(data.totalReceivables)} icon="ri-history-line" type="receivable" />
//               <KPICard title="Payables" value={format(data.totalPayables)} icon="ri-bank-card-2-line" type="payable" />
//             </div>

//             {/* LISTS ROW */}
//             <div className="row g-4">
//               <div className="col-lg-6">
//                 <div className="mgaccount-content-card shadow-sm">
//                   <div className="mgaccount-card-header-v2">
//                     <h5>Top Outstanding Agents</h5>
//                     <div className="mgaccount-count-tag warn">{data.pendingSalesCount || 0} PENDING</div>
//                   </div>
//                   <div className="table-responsive">
//                     <table className="mgaccount-modern-table">
//                       <tbody>
//                         {data.topReceivableAgents?.map((p, i) => (
//                           <tr key={i}>
//                             <td className="fw-medium">{p.partyName}</td>
//                             <td className="text-end fw-bold text-danger">{format(p.balance)}</td>
//                           </tr>
//                         ))}
//                         {(!data.topReceivableAgents || data.topReceivableAgents.length === 0) && 
//                           <tr><td colSpan="2" className="text-center py-4 text-muted">No pending receivables</td></tr>
//                         }
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               <div className="col-lg-6">
//                 <div className="mgaccount-content-card shadow-sm">
//                   <div className="mgaccount-card-header-v2">
//                     <h5>Supplier Balance Summary</h5>
//                   </div>
//                   <div className="table-responsive">
//                     <table className="mgaccount-modern-table">
//                       <tbody>
//                         {data.topPayableSuppliers?.map((p, i) => (
//                           <tr key={i}>
//                             <td className="fw-medium">{p.partyName}</td>
//                             <td className="text-end">
//                                 <div className="fw-bold fs-6">{format(p.balance)}</div>
//                                 <span className={`mgaccount-mini-label ${p.status === 'Debt' ? 'mgaccount-lbl-warn' : 'mgaccount-lbl-success'}`}>
//                                     {p.status === "Debt" ? "You Owe" : "Advance"}
//                                 </span>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : !loading && <div className="mgaccount-no-data">No Data Found for this range</div>}
//       </div>
//     </div>
//     </div>
//     </div>
//   );
// };

// const KPICard = ({ title, value, icon, type }) => (
//   <div className="col-xl col-md-4 col-sm-6">
//     <div className={`mgaccount-card-kpi mgaccount-card-${type} shadow-sm`}>
//       <div className="mgaccount-kpi-icon-v3"><i className={icon}></i></div>
//       <div className="mgaccount-kpi-body-v3">
//         <span className="mgaccount-kpi-title">{title}</span>
//         <h4 className="mgaccount-kpi-val">{value}</h4>
//       </div>
//     </div>
//   </div>
// );

// export default MongoAccountingDashboard;
import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import "./MongoAccountingDashboard.css";
import Header from "../../Common/Layout/Header";
import AccountTabs from "../AllTabs/AccountTabs";

const MongoAccountingDashboard = () => {
  const { user } = useAuth();
  
  // Set initial state with zeros so the UI is visible immediately
  const [data, setData] = useState({
    totalIncome: 0,
    totalExpenses: 0,
    netProfit: 0,
    totalReceivables: 0,
    totalPayables: 0,
    pendingSalesCount: 0,
    topReceivableAgents: [],
    topPayableSuppliers: []
  });
  
  const [loading, setLoading] = useState(true);
  
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

 const fetchDashboard = async () => {
    if (!user?.cid) return;
    setLoading(true);
    try {
      const url = `${config.GETMONGOACCOUNTINGDASHBOARD}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`;
      const res = await apiService.getAll(url);
      if (res) {
        setData(res);
      }
    } catch (err) {
      console.error("Error fetching dashboard:", err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (user?.cid) fetchDashboard();
  }, [user?.cid]);

  const format = (v) => 
    "INR " + Number(v || 0).toLocaleString("en-IN", { 
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

  return (
   <div id="layout-wrapper">
     <Header User={user} activeSection="accounts" />

    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">

          {/* ACCOUNT TABS */}
          <div className="row mb-3">
            <div className="col-12">
              <AccountTabs pageName="ACCOUNTDASHBOARD" />
            </div>
          </div>

          {/* TOP ACTION BAR */}
          <div className="row align-items-center mb-4">
            <div className="col-md-6">
              <h3 className="mgaccount-page-heading">Financial Overview</h3>
              <span className="mgaccount-subheading">
                Real-time accounting insights for {user?.companyname}
              </span>
            </div>

            <div className="col-md-6">
              <div className="mgaccount-filter-card shadow-sm">
                <div className="d-flex align-items-end gap-3">
                  <div className="mgaccount-date-input-group">
                    <label>From Date</label>
                    <input
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="mgaccount-date-input-group">
                    <label>To Date</label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                  <button
                    className="mgaccount-btn-update"
                    onClick={fetchDashboard}
                    disabled={loading}
                  >
                    {loading ? "..." : "Generate Report"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* KPI ROW - Always visible, values populate when data arrives */}
          <div className="row g-3 mb-4">
            <KPICard title="Total Income" value={format(data.totalIncome)} icon="ri-line-chart-line" type="income" loading={loading} />
            <KPICard title="Total Expenses" value={format(data.totalExpenses)} icon="ri-pie-chart-line" type="expense" loading={loading} />
            <KPICard title="Net Profit" value={format(data.netProfit)} icon="ri-hand-coin-line" type="profit" loading={loading} />
            <KPICard title="Receivables" value={format(data.totalReceivables)} icon="ri-history-line" type="receivable" loading={loading} />
            <KPICard title="Payables" value={format(data.totalPayables)} icon="ri-bank-card-2-line" type="payable" loading={loading} />
          </div>

          {/* LISTS ROW - Always visible */}
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="mgaccount-content-card shadow-sm">
                <div className="mgaccount-card-header-v2">
                  <h5>Top Outstanding Agents</h5>
                  <div className="mgaccount-count-tag warn">{data.pendingSalesCount || 0} PENDING</div>
                </div>
                <div className="table-responsive">
                  <table className="mgaccount-modern-table">
                    <tbody>
                      {data.topReceivableAgents?.map((p, i) => (
                        <tr key={i}>
                          <td className="fw-medium">{p.partyName}</td>
                          <td className="text-end fw-bold text-danger">{format(p.balance)}</td>
                        </tr>
                      ))}
                      {(!data.topReceivableAgents || data.topReceivableAgents.length === 0) && 
                        <tr><td colSpan="2" className="text-center py-4 text-muted">
                          {loading ? "Fetching records..." : "No pending receivables"}
                        </td></tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mgaccount-content-card shadow-sm">
                <div className="mgaccount-card-header-v2">
                  <h5>Supplier Balance Summary</h5>
                </div>
                <div className="table-responsive">
                  <table className="mgaccount-modern-table">
                    <tbody>
                      {data.topPayableSuppliers?.map((p, i) => (
                        <tr key={i}>
                          <td className="fw-medium">{p.partyName}</td>
                          <td className="text-end">
                              <div className="fw-bold fs-6">{format(p.balance)}</div>
                              <span className={`mgaccount-mini-label ${p.status === 'Debt' ? 'mgaccount-lbl-warn' : 'mgaccount-lbl-success'}`}>
                                  {p.status === "Debt" ? "You Owe" : "Advance"}
                              </span>
                          </td>
                        </tr>
                      ))}
                      {(!data.topPayableSuppliers || data.topPayableSuppliers.length === 0) && 
                        <tr><td colSpan="2" className="text-center py-4 text-muted">
                           {loading ? "Fetching records..." : "No data found"}
                        </td></tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

// Added an opacity effect when loading so the user knows data is updating
const KPICard = ({ title, value, icon, type, loading }) => (
  <div className="col-xl col-md-4 col-sm-6">
    <div className={`mgaccount-card-kpi mgaccount-card-${type} shadow-sm`} style={{ opacity: loading ? 0.6 : 1, transition: '0.3s opacity' }}>
      <div className="mgaccount-kpi-icon-v3"><i className={icon}></i></div>
      <div className="mgaccount-kpi-body-v3">
        <span className="mgaccount-kpi-title">{title}</span>
        <h4 className="mgaccount-kpi-val">{value}</h4>
      </div>
    </div>
  </div>
);

export default MongoAccountingDashboard;